<template>
  <div>Avatar picker</div>
</template>
<script>
export default {
  name: 'AvatarPicker'
}
</script>
